module.exports = __webpack_public_path__ + "img/时间轴.jpg";